import { PencilIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import { ActionIcon, Button, Table, Title } from '@mantine/core';
import cn from 'clsx';
import { useNavigate } from 'react-router-dom';

import { DeleteCategoryModal } from '@/features/delete-category-modal';
import { RouteList } from '@/shared/constants';
import { useProjectPath } from '@/shared/projects/project-path';
import { useCategoriesStore } from '@/shared/stores/categories.store';

import { useGetCategories } from '../model/categories-page.cases';
import styles from './categories-page.module.scss';

const CategoriesPage = () => {
  const navigate = useNavigate();
  const withProject = useProjectPath();
  const getCategoriesQuery = useGetCategories();
  const setDeletableCategory = useCategoriesStore(
    (state) => state.setDeletableCategory,
  );

  return (
    <div className={styles.container}>
      <Title order={1} size={44} className={styles.title}>
        Категории
      </Title>
      <div className={styles.header}>
        <Button
          size="lg"
          leftSection={<PlusIcon width={20} height={20} />}
          onClick={() => navigate(withProject(RouteList.CREATE_CATEGORY))}
        >
          Добавить категорию
        </Button>
      </div>
      <DeleteCategoryModal />
      <Table.ScrollContainer minWidth="100%" className={styles.table}>
        <Table withTableBorder flex={1}>
          <Table.Thead>
            <Table.Tr>
              <Table.Th
                className={cn(styles.tableHeadCell, styles.categoryHeadCell)}
              >
                Название
              </Table.Th>
              <Table.Th className={styles.tableHeadCell}>Обложка</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {getCategoriesQuery.data.categories.map((category) => (
              <Table.Tr key={category.id} className={styles.tableRow}>
                <Table.Td
                  width="50%"
                  className={styles.categoryTitleCell}
                  onClick={() =>
                    navigate(
                      withProject(
                        RouteList.CATEGORY_DETAILS(String(category.id)),
                      ),
                    )
                  }
                >
                  {category.title}
                </Table.Td>
                <Table.Td width="40%">
                  <img
                    src={category.imgUrl}
                    alt={category.title}
                    className={styles.categoryPreviewImage}
                  />
                </Table.Td>
                <Table.Td width="10%">
                  <div className={styles.actions}>
                    <ActionIcon
                      variant="subtle"
                      size="lg"
                      color="gray"
                      onClick={() =>
                        navigate(
                          withProject(
                            RouteList.EDIT_CATEGORY(String(category.id)),
                          ),
                        )
                      }
                    >
                      <PencilIcon width={24} height={24} />
                    </ActionIcon>
                    <ActionIcon
                      variant="subtle"
                      size="lg"
                      color="gray"
                      onClick={() =>
                        setDeletableCategory({
                          id: category.id,
                          title: category.title,
                        })
                      }
                    >
                      <TrashIcon width={24} height={24} />
                    </ActionIcon>
                  </div>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </div>
  );
};

export default CategoriesPage;
